"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(message, value) {
    value.event = 'GApagespeed';
    value.eventCategory = 'Performance Metrics';
    value.eventAction = message.name || '';
    value.eventValue = message.value;
    return value;
}
exports.default = default_1;
